// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const Select = (el) => {
  const ui = {
    el,
    body: select('body', document),
    form: select ('.language-select'),
  };
  
  // console.log(ui);

  const handleChange = () => {
    if (ui.form) {
      ui.form.submit();
    }
  };

  const addEvents = () => {
    if (ui.el?.getAttribute('id') === 'lang-select') {
      ui.el.addEventListener('change', () => {
        handleChange();
      });
    }
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default Select;
